import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-61-montek-singh-guest.webp";
import ThumbImg from "../../assets/images/conversations/061.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";


/* ─────────────────────────────────────────────
   PREFIX: ms-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .ms-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }

  /* ── INNER ── */
  .ms-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 — HERO (2-col)
  ══════════════════════════════════════ */
  .ms-hero {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .ms-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }

  /* LEFT */
  .ms-hero__left {
    display: flex;
    flex-direction: column;
    gap: 44px;
  }
  .ms-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .ms-hero__title.ms-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .ms-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .ms-hero__spotify.ms-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .ms-hero__spotify iframe {
    display: block;
    width: 100%;
    height: 152px;
    border: none;
    border-radius: 12px;
  }

  /* RIGHT */
  .ms-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .ms-hero__right.ms-visible {
    opacity: 1;
    transform: translateY(0);
  }

  /* thumbnail wrapper */
  .ms-yt-thumb {
    position: relative;
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    display: block;
    background: #000;
  }
  .ms-yt-thumb img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 12px;
    transition: opacity 0.3s ease;
  }
  .ms-yt-thumb:hover img {
    opacity: 0.85;
  }

  /* play button */
  .ms-yt-thumb__play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    
    background: none;
    
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.25s ease;
    pointer-events: none;
  }
  .ms-yt-thumb__play img {
   width: 40px;
    height: 44px;
    margin-left: 4px;
    fill: #ffffff;
  }

  /* iframe */
  .ms-yt-iframe-wrap {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    border-radius: 12px;
    overflow: hidden;
  }
  .ms-yt-iframe-wrap iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 — BODY
  ══════════════════════════════════════ */
  .ms-body {
    padding-bottom: 100px;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .ms-body.ms-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .ms-body__para {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #E2E2E2;
    line-height: 160%;
    margin-bottom: 14px;
  }
  .ms-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 — OUR GUEST
  ══════════════════════════════════════ */
  .ms-guest {
    padding-bottom: 100px;
    text-align: center;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .ms-guest.ms-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .ms-guest__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 60px;
  }
  .ms-guest__photo-bg {
    display: inline-block;
    width: 445px;
    height: 500px;
    background: #743FAC;
    border-radius: 12px;
    overflow: hidden;
  }
  .ms-guest__photo-bg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    display: block;
  }
  .ms-guest__name {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .ms-inner { padding-left: 32px; padding-right: 32px; }
    .ms-hero { padding-top: 32px; padding-bottom: 48px; }
    .ms-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .ms-hero__title { font-size: 24px; }
    .ms-hero__left { gap: 16px; }
    .ms-guest__title { font-size: 24px; margin-bottom: 24px; }
    .ms-guest__name { font-size: 24px; margin-top: 18px; }
    .ms-guest__photo-bg { width: 260px; height: 300px; }
    .ms-body__para { font-size: 14px; margin-bottom: 12px; }
    .ms-body { padding-bottom: 48px; }
    .ms-guest { padding-bottom: 48px; }
     .ms-yt-thumb__play img {  width: 30px; height: 32px;}
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .ms-inner { padding-left: 16px; padding-right: 16px; }
    .ms-hero { padding-top: 51px; padding-bottom: 30px; }
    .ms-hero__grid { grid-template-columns: 1fr; gap: 40px; }
    .ms-hero__left { gap: 30px; }
    .ms-hero__title { font-size: 30px; }
    .ms-body__para { font-size: 16px; margin-bottom: 10px; }
    .ms-guest__title { font-size: 30px; margin-bottom: 20px; }
    .ms-guest__photo-bg { width: 100%; height: 386px; }
    .ms-guest__name { font-size: 24px; text-align: left; }
    .ms-body { padding-bottom: 30px; }
    .ms-guest { padding-bottom: 30px; }
     .ms-yt-thumb__play img {  width: 30px; height: 32px;}

  }
`;

/* ─────────────────────────────────────────────
   FADE-UP HOOK
───────────────────────────────────────────── */
function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("ms-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

/* ─────────────────────────────────────────────
   YOUTUBE EMBED
───────────────────────────────────────────── */
const YT_VIDEO_ID = "ZDgTz0hZHx0";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);

  if (playing) {
    return (
      <div className="ms-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 61 Montek Singh Ahluwalia"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="ms-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 61 Montek Singh Ahluwalia thumbnail" />
      <div className="ms-yt-thumb__play">
                <img src={PlayIcon} />
        
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   SECTIONS
───────────────────────────────────────────── */
function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);

  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="ms-hero">
      <div className="ms-inner">
        <div className="ms-hero__grid">

          {/* LEFT */}
          <div className="ms-hero__left">
            <h1 ref={titleRef} className="ms-hero__title">
              EP 61 | 1991: India's Near-Default Moment. How Did We Survive — and in 2025 What Challenges Come Next? | Montek Singh AHLUWALIA
            </h1>
            <div ref={spotifyRef} className="ms-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/0qI0ST6j30Acu2RUEL4LvB?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 61 Spotify Player"
              />
            </div>
          </div>

          {/* RIGHT */}
          <div ref={rightRef} className="ms-hero__right">
            <YouTubeEmbed />
          </div>

        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="ms-body">
      <div className="ms-inner">
        <p className="ms-body__para">
          1991: India's Near-Default Moment. How Did We Survive — and in 2025 What Challenges Come Next? | Montek Singh AHLUWALIA
        </p>
        <p className="ms-body__para">
          On this program, we engage with the key thinkers and leaders shaping India's economic, energy, and policy landscape. I'm your host, Ravin MIRCHANDANI, and today, honestly, I'm a little bit starstruck. Joining us on the show is someone we have admired for years and who really needs no introduction at all to the business audience, as he was one of the true architects of the modern India that we inhabit today.
        </p>
        <p className="ms-body__para">
          A journey that the country commenced in 1991, Montec Singh AHLUWALIA is an economist, a policy visionary, and also a civil servant who, along with the then-prime minister Manmohan Singh, played a pivotal role in steering India during its 1991 economic crisis. A moment of near default, where the country had to pledge its gold to keep the economy afloat. He served as the deputy chairman of the planning commission from 2004 to 2014, holding the rank of cabinet minister, and before that, he was the first director of the Independent Evaluation Office of the IMF.
        </p>
        <p className="ms-body__para">
          Today we go behind the scenes of that 1991 crisis, what really happened in those 10 stays, battles that were fought in the coridoors of power and how india chose the path of liberalisation, we will also look ahead to the turbulence of the present moment, global trade wars, tariff barriers, and the new era of supply chain of geo politics, what does all of this mean to india and how do we charte the path forward.
        </p>
        <p className="ms-body__para">
          This is a rare and candid conversation with a man who has seen it all from Washington to New Delhi and has helped shape India's economic destiny. Montec Singh AHLUWALIA, the man with the perennial blue turban, welcome to the program!
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="ms-guest">
      <div className="ms-inner">
        <h2 className="ms-guest__title">Our Guest</h2>
        <div>
          <div className="ms-guest__photo-bg">
            <img src={GuestImg} alt="Montek Singh Ahluwalia" />
          </div>
          <p className="ms-guest__name">Montek Singh</p>
        </div>
      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function Ep61MontekSingh() {
  return (
    <>
      <style>{CSS}</style>
      <div className="ms-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}